import React from 'react'

const Highlightcard = ({ lineone, linetwo, linethree, image }) => {
    return (
        <div className='flex flex-row rounded bg-[#FFD89C] p-0'>
            <div className='w-2/3 p-[15px]'>
                <p className='brand-font text-[20px]'>{lineone}</p>
                <p className='brand-font text-[20px] bottom15px'>{linetwo}</p>
                <p className='brand-text txt-bold text-[22px]'>{linethree}</p>
            </div>
            <div className='w-1/3 h-full justify-end self-end mr-[-15px]'>
                <img src={image} alt="8th Wonder Game" />
            </div>
        </div>
    )
}

export default Highlightcard